import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Helmet } from "react-helmet";

import Navbar from "../common/Navbar";
import Footer from "../common/Footer";
import DigitalMarketingChennai from "../components/blogs/DigitalMarketingChennai";

const DigitalMarketingAgencyChennai = () => {
  const location = useLocation();

  useEffect(() => {
    if (!location.search) {
      window.scrollTo(0, 0);
    }
  }, [location]);

  return (
    <>
      <Helmet>
        <title>Digital Marketing Services in Chennai | SMS ZOO ZOO</title>
        <meta
          name="description"
          content="Looking for digital marketing services in Chennai? SMS ZOO ZOO helps businesses grow with SEO, Google Ads, social media, and lead generation."
        />

        <meta name="robots" content="index, follow" />
        <link
          rel="canonical"
          href="https://www.smszoozoo.com/digital-marketing-agency-chennai"
        />
      </Helmet>

      <Navbar />
      <DigitalMarketingChennai />
      <Footer />
    </>
  );
};

export default DigitalMarketingAgencyChennai;
